const u = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

/**
 * Every entry below is a DISTINCT photograph - no image is reused anywhere on
 * the site, and each one is chosen to match the subject of its own section.
 */
export const IMAGES = {
  // cinematic hero crossfade - one scene per pillar of the LYKIT ecosystem
  hero: [
    { src: u("photo-1470229722913-7c0e2dbbafd3", 2200), label: "Live Events" },
    { src: u("photo-1459749411175-04bf5292ceea", 2200), label: "Stage & Sound" },
    { src: u("photo-1516035069371-29a1b244cc32", 2200), label: "Film Production" },
    { src: u("photo-1517604931442-7e0c8ed2963c", 2200), label: "Cinema & OTT" },
    { src: u("photo-1598488035139-bdbb2231ce04", 2200), label: "Post-Production" },
    { src: u("photo-1559027615-cd4628902d4a", 2200), label: "Social Impact" },
  ],

  // full-bleed editorial banner below the Who We Are copy
  whoWeAre: "/brand/who-we-are-banner.jpg",

  verticals: {
    events: u("photo-1531058020387-3be344556be6", 1200), // packed auditorium
    advertisingA: u("photo-1626814026160-2237a95fc5a0", 900), // poster / campaign wall
    advertisingB: u("photo-1611162617213-7d7a39e9b1d7", 900), // social / brand channels
    socialImpact: u("photo-1615461066841-6116e61058f4", 1200), // community blood-donation drive
    ott: u("photo-1593784991095-a205069470b6", 1800), // streaming apps on TV
    postProduction: u("photo-1574717024653-61fd2cf4d44d", 1100), // edit timeline
  },

  services: {
    events: {
      hero: u("photo-1540039155733-5bb30b53aa14", 2000), // crowd, hands up
      gallery: [
        u("photo-1505236858219-8359eb29e329", 1200), // concert lighting
        u("photo-1591115765373-5207764f72e7", 1200), // conference stage
      ],
    },
    advertising: {
      hero: u("photo-1524253482453-3fed8d2fe12b", 2000), // shooting content
      gallery: [
        u("photo-1531545514256-b1400bc00f31", 1200), // creative team session
        u("photo-1552664730-d307ca884978", 1200), // campaign planning wall
      ],
    },
    "ott-digital": {
      hero: u("photo-1567443024551-f3e3cc2be870", 2000), // streaming on tablet
      gallery: [
        u("photo-1478720568477-152d9b164e26", 1200), // projection / screening
        u("photo-1560472354-b33ff0c44a43", 1200), // audience analytics
      ],
    },
    "post-production": {
      hero: u("photo-1492619375914-88005aa9e8fb", 2000), // edit suite monitor
      gallery: [
        u("photo-1598653222000-6b7b7a552625", 1200), // studio desk + mic
        u("photo-1478737270239-2f02b77fc618", 1200), // studio microphone
      ],
    },
    "social-impact": {
      hero: u("photo-1593113598332-cd288d649433", 2000), // relief supplies / volunteering
      gallery: [
        u("photo-1509062522246-3755977927d7", 1200), // classroom
        u("photo-1584515933487-779824d29309", 1200), // hands / care
      ],
    },
  },

  about: {
    hero: u("photo-1519683109079-d5f539e1542f", 2000), // orchestra hall
    story: u("photo-1485846234645-a62644f84728", 1400), // clapperboard
    ecosystem: u("photo-1522071820081-009f0129c71c", 1400), // team at work
  },

  careers: {
    hero: u("photo-1581091226825-a6a2a5aee158", 2000), // working at a desk
    culture: u("photo-1600880292203-757bb62b4baf", 1200), // team celebrating
  },

  work: { hero: u("photo-1598387993441-a364f854c3e1", 2000) }, // band on stage
  contact: { hero: u("photo-1497366754035-f200968a6e72", 2000) }, // studio corridor

  socialImpact: {
    hero: u("photo-1600880292089-90a7e086ee0c", 2000), // hands joined in unity
    band: u("photo-1532629345422-7515f3d16bb6", 1600), // hands reaching out
    crowdfunding: u("photo-1567427017947-545c5f8d16ad", 1400), // coins / giving jar
    focus: {
      Healthcare: u("photo-1505751172876-fa1923c5c528", 900), // stethoscope
      Education: u("photo-1522202176988-66273c2fd55f", 900), // students learning
      "Elder Care": u("photo-1576765608535-5f04d1e3f289", 900), // nurse with elder
      "Child Welfare": u("photo-1497486751825-1233686d5d80", 900), // children
      Rehabilitation: u("photo-1516321318423-f06f85e504b3", 900), // clinical recovery care
      Livelihood: u("photo-1604881991720-f91add269bed", 900), // small enterprise craft
      "Community Development": u("photo-1521791136064-7986c2920216", 900), // partnership
    },
  },

  brand: {
    logoDark: "/brand/lykit-logo-dark.png",
    logoWhite: "/brand/lykit-logo-white.png",
    mark: "/brand/lykit-mark.png",
    watermark: "/brand/lykit-watermark.png",
  },

  founders: {
    pavan: "/brand/founder-pavan.jpg",
    ravishekar: "/brand/founder-ravishekar-ivory.jpg",
  },

  // LYKIT ENTERTAINMENT x IBMCT collaboration (supplied photograph)
  collaboration: {
    ibmct: "/brand/lykit-x-ibmct.jpg",
  },
};

export default IMAGES;
